/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import BiddingItems from 'components/atoms/bidding_items';
import PhoneCard from 'components/atoms/phone_card';
import React, { useEffect, useState } from 'react';
import { BiddingData } from 'store/modules/bidding_store/types';
import MonitoringPortals from 'services/monitoring_portals';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useDispatch, useSelector } from 'react-redux';
import RobotCreateProposalButton from 'components/atoms/robot_proposal_button';
import PartnerLogo from 'components/atoms/partner_logo';
import BiddingHeader from 'components/atoms/bidding_header';
import BiddingCommentsList from 'components/organisms/bidding_comments_list';
import MonitoreButton from 'components/atoms/monitore_button';
import ManagementButton from 'components/atoms/management_button/management_button';
import BiddingAttachmentList from 'components/molecules/bidding_attachment_list';
import ManagementTask from 'components/molecules/management_task';
import MapLink from 'components/atoms/map_link';
import BiddingDate from 'components/atoms/bidding_date';
import { PanelState } from 'store/modules/panel_store/types';
import ModalOrganDetails from 'components/molecules/modal_organ_details';
import ManagementRemoveBidding from 'components/atoms/management_remove_bidding';
import { ManagementState } from 'store/modules/management_store/types';
import { BulletinBiddingsTypes, BulletinsState } from 'store/modules/bulletins_store/types';
import _ from 'underscore';
import RobotComprasnetWarning from 'components/atoms/robot_comprasnet_warning';
import HighlightedText from 'components/atoms/highlighted_text';
import BiddingFollowupList from 'components/organisms/bidding_followup_list';
import { solicitarEdital } from 'store/modules/bidding_store/actions';
import { getBiddingSummary } from 'store/modules/management_store/actions';
import useRefetchOnModalMutation from 'hooks/useRefetchOnModalMutation';
import createTrack from 'services/actions/tracker_actions';
import SquareLoader from 'components/atoms/square_loader';
import BiddingSummaryButton from 'components/atoms/bidding_summary_button';
import BiddingChatButton from 'components/atoms/bidding_chat_button';
import { Container } from './styles';
import BiddingInfoDropdown from '../../atoms/bidding_info_dropdown';

interface BiddingItemProps {
  bidding: BiddingData | BulletinBiddingsTypes;
  biddingIndex: number;
  isChecked: boolean;
  source?:
    | 'biddings'
    | 'management'
    | 'imminence'
    | 'bulletin'
    | 'biddingDetails'
    | 'share'
    | 'favorited';
  favoritedSource?: string;
  commentSource?: 'biddings' | 'management' | 'imminence' | 'bulletin';
  bulletinFilterId?: number;
  bulletinFilterIndex?: number;
  toggleSelected?: (id: number, updateAll?: boolean) => void;
}

const BiddingItem = (props: BiddingItemProps) => {
  const {
    bidding,
    biddingIndex,
    isChecked,
    source = 'biddings',
    favoritedSource = 'bidding',
    commentSource = 'biddings',
    bulletinFilterId = 0,
    bulletinFilterIndex = 0,
    toggleSelected = () => {},
  } = props;
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { management, request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );
  const { bulletins } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );
  const [taskCountRefreshed, setTaskCountRefreshed] = useState<boolean>(false);

  const [ItemsOpened, setItemsOpened] = useState<boolean>(false);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [FollowupOpened, setFollowupOpened] = useState<boolean>(false);
  const [modalManagementTaskOpened, setModalManagementTaskOpened] = useState<boolean>(false);
  const [taskType, setTaskType] = useState<string>('');
  const [modalOrganDetailsOpened, setModalOrganDetailsOpened] = useState<boolean>(false);
  const [modalRemoveBiddingOpened, setModalRemoveBiddingOpened] = useState<boolean>(false);
  const [modalRobotWarningOpened, setModalRobotWarningOpened] = useState<boolean>(false);
  const portals = MonitoringPortals();
  const ALLOWED_ROBOT_PORTALS = [
    'Licitanet',
    'BLL Compras',
    'Bolsa Nacional de Compras (BNC)',
    'ComprasNet',
    'Portal de Compras Publicas',
    'ComprasNet DL',
  ];
  const [requestEdital, setRequestEdital] = useState(false);
  const [messageEditalSuccess, setMessageEditalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [solicited, setSolicited] = useState(bidding?.has_requested_edital);

  useEffect(() => {
    if (FollowupOpened) setItemsOpened(false);
  }, [FollowupOpened]);

  useRefetchOnModalMutation(
    modalManagementTaskOpened,
    [request.create_tasks?.loaded, request.create_progress?.loaded],
    () => {
      dispatch(
        getBiddingSummary(Number(bidding.bidding_id) || Number(bidding.id), companyId(profile)),
      );
      setTaskCountRefreshed(true);
    },
  );

  const totalManagedTasks = () => {
    const biddingId = Number(bidding.bidding_id) || Number(bidding.id);
    const summaryTotal = management.bidding_summary?.[biddingId]?.total_managed_opened_tasks;
    if (taskCountRefreshed && summaryTotal != null) return summaryTotal;
    return (
      bidding.total_managed_opened_tasks ??
      summaryTotal ??
      management.managed.find((managed) => managed.id === biddingId)?.total_managed_opened_tasks ??
      0
    );
  };

  const handleClickEdital = async (bidding_id: number | string) => {
    setLoading(true);
    try {
      createTrack(`${source} - Solicitou edital`);
      await dispatch(solicitarEdital(bidding_id));
      setMessageEditalSuccess(true);
    } catch (error) {
      console.error('Erro ao solicitar edital:', error);
    } finally {
      setLoading(false);
      setSolicited(true);
      setRequestEdital(false);
    }
  };

  return (
    <Container className="row">
      <div className="col-12 p-0">
        <div
          className={`card shadow bidding mb-5 ${isChecked ? 'bidding_selected' : 'd-print-none'}`}
        >
          <BiddingHeader
            source={source}
            bidding_updated={bidding.modified || ''}
            biddingId={bidding.bidding_id.toString() || bidding.id.toString()}
            biddingIndex={biddingIndex}
            isChecked={isChecked}
            toggleSelected={toggleSelected}
            isFavorited={bidding.favorited}
            contactList={bidding.favorited_by}
            favoritedSource={favoritedSource}
            bulletinFilterId={bulletinFilterId}
            isViewed={bidding.viewed_by_user}
            isViewedBy={bidding.viewed_by}
          />
          <div className={`card-body p-3 ${bidding.viewed_by_user ? 'bidding-viewed' : ''}`}>
            <div className="row bidding-info mb-3 d-print-none">
              <div className="col-md-12">
                {bidding.has_electronic_trading && source !== 'share' && (
                  <MonitoreButton
                    isMonitored={bidding.monitored_by_user}
                    biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                    source={source}
                  />
                )}
                {source !== 'biddingDetails' && source !== 'share' && (
                  <ManagementButton
                    bidding={bidding}
                    biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                    setModalManagementTaskOpened={setModalManagementTaskOpened}
                    setTaskType={setTaskType}
                    isManaged={bidding.managed}
                    setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
                    bulletinId={bulletinFilterId}
                    source={source}
                  />
                )}
                {source !== 'share' &&
                  panel.allow_robot &&
                  portals
                    .filter((portal) => ALLOWED_ROBOT_PORTALS.includes(portal.label))
                    .map((portal) => portal.value)
                    .includes(bidding.electronic_trading?.source_id) && (
                    <RobotCreateProposalButton
                      newLaw={_.isNull(bidding.electronic_trading?.trading_id)}
                      setModalRobotWarningOpened={setModalRobotWarningOpened}
                      bidding={bidding}
                    />
                  )}
                {source !== 'share' &&
                  panel?.validate_services?.robo &&
                  portals
                    .filter((portal) => ALLOWED_ROBOT_PORTALS.includes(portal.label))
                    .map((portal) => portal.value)
                    .includes(bidding.electronic_trading?.source_id) && (
                    <RobotCreateProposalButton
                      newLaw={_.isNull(bidding.electronic_trading?.trading_id)}
                      setModalRobotWarningOpened={setModalRobotWarningOpened}
                      bidding={bidding}
                    />
                  )}
                {source !== 'share' &&
                  panel?.validate_services?.robo &&
                  profile.alfa_tester &&
                  bidding.electronic_trading?.source_id === 857 && (
                    <RobotCreateProposalButton
                      newLaw={_.isNull(bidding.electronic_trading?.trading_id)}
                      setModalRobotWarningOpened={setModalRobotWarningOpened}
                      bidding={bidding}
                    />
                  )}
              </div>
            </div>
            <div className="tour-bidding-info border rounded-top pt-2 px-2">
              <div className="row bidding-info mb-2">
                <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                  Objeto
                </div>
                {source !== 'bulletin' && (
                  <div
                    className="col-md-11"
                    dangerouslySetInnerHTML={{ __html: bidding.objeto || '-' }}
                  />
                )}
                {source === 'bulletin' && (
                  <HighlightedText
                    className="col-md-11"
                    termsList={bulletins?.filter_bulletins[bulletinFilterIndex]?.bidding_keywords}
                    text={bidding.objeto}
                    removeAcronym
                  />
                )}
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                  Datas
                </div>
                <div className="col-md-5">
                  {!bidding.datahora_abertura &&
                    !bidding.datahora_prazo &&
                    !bidding.datahora_documento &&
                    !bidding.datahora_retirada &&
                    !bidding.datahora_visita &&
                    'Não Informadas'}
                  {bidding.datahora_abertura && (
                    <BiddingDate date={bidding.datahora_abertura} dateType="Abertura" />
                  )}
                  {bidding.datahora_prazo && (
                    <BiddingDate date={bidding.datahora_prazo} dateType="Prazo" />
                  )}
                  {bidding.datahora_documento && (
                    <BiddingDate date={bidding.datahora_documento} dateType="Documento" />
                  )}
                  {bidding.datahora_retirada && (
                    <BiddingDate date={bidding.datahora_retirada} dateType="Retirada" />
                  )}
                  {bidding.datahora_visita && (
                    <BiddingDate date={bidding.datahora_visita} dateType="Visita" />
                  )}
                </div>

                <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                  Situação
                </div>
                <div className="col-md-4">
                  <span
                    className={`bidding-situation-${bidding.bidding_grouping?.descricao?.replace(
                      /\s/g,
                      '-',
                    )}`.toLowerCase()}
                    dangerouslySetInnerHTML={{
                      __html: bidding.bidding_grouping.descricao || '-',
                    }}
                  />
                </div>
              </div>

              <div className="row bidding-info mb-2">
                <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                  Edital
                </div>
                <div
                  className="col-md-5 text-secondary"
                  dangerouslySetInnerHTML={{ __html: bidding.edital || '-' }}
                />

                <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                  Nº Conlicitação
                </div>
                <div
                  className="col-md-2"
                  dangerouslySetInnerHTML={{ __html: bidding.bidding_id.toString() || '-' }}
                />
              </div>

              <div className="row bidding-info mb-2">
                <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                  Órgão
                </div>

                <div className="col-md-11">
                  <button
                    type="button"
                    aria-label="Clique para ver licitações já realizadas por esse órgão."
                    data-balloon-pos="up"
                    className="databalloon btn btn-link p-0 break-text text-left d-md-flex d-block align-items-center"
                    onClick={() => {
                      setModalOrganDetailsOpened(true);
                      createTrack(`Card - Clicou no órgão em ${source}`);
                    }}
                  >
                    {!bidding?.orgao_uasg && !bidding?.public_body?.nome && '-'}
                    {bidding?.orgao_uasg}
                    {`${bidding.orgao_uasg ? ' - ' : ''}`}
                    {bidding?.public_body?.nome}
                    <i className="material-icons bidding-info-icon ml-1">info</i>
                  </button>
                </div>
              </div>

              <div className="row bidding-info mb-2">
                <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                  Cidade
                </div>
                <div className="col-md-11">
                  {bidding.orgao_cidade} -{' '}
                  <span className="bidding-info-state">{bidding.orgao_estado}</span>
                  <MapLink
                    address={`${bidding.orgao_endereco} ${bidding.orgao_cidade} ${bidding.orgao_estado}`}
                    source={source}
                  />
                </div>
              </div>
              {bidding?.status_bidding_info?.length > 0 && (
                <div className="row bidding-info mb-2">
                  <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                    Link
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="button"
                          className="btn btn-link p-0 border-0"
                          onClick={(event) => {
                            event.preventDefault();
                            createTrack(`Card - Clicou Acessar local de disputa em ${source}`);
                            window.open(bidding?.status_bidding_info?.[0]?.url_portal, '_blank');
                          }}
                        >
                          Acessar local da disputa
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                    Status da Sessão
                  </div>
                  <div className="col-md-4">{bidding?.status_bidding_info?.[0]?.status_name}</div>
                </div>
              )}

              {bidding.edital_preco > 0 && (
                <div className="row bidding-info mb-2 align-items-center">
                  <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                    Preço Edital
                  </div>
                  <div className="col-md-2">{`R$ ${bidding.edital_preco
                    .toString()
                    .replace('.', ',')
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}</div>
                </div>
              )}
              {bidding.valor_estimado > 0 && (
                <div className="row bidding-info mb-2 align-items-center">
                  <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                    Valor Estimado
                  </div>
                  <div className="col-md-2">
                    <span className="bg-warning p-1">
                      {`R$ ${bidding.valor_estimado
                        .toString()
                        .replace('.', ',')
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}`}
                    </span>
                  </div>
                </div>
              )}
              <div
                className={`bidding-hidden-info d-print-block ${
                  BiddingInfoToggle ? 'd-block' : 'd-none'
                }`}
              >
                <div className="row bidding-info mb-2">
                  <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                    Obs
                  </div>
                  <div className="col-md-11 text-secondary">
                    {bidding.observacao || 'Sem Observação'}
                  </div>
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-1 pr-0 p-md-0 text-left text-md-right bidding-info-title mt-2 mt-md-0">
                    Processo
                  </div>
                  <div
                    className="col-md-5 text-secondary"
                    dangerouslySetInnerHTML={{ __html: bidding.processo || '-' }}
                  />
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-1 text-left text-md-right pr-0 bidding-info-title">
                    Tel
                  </div>
                  <div className="col-md-5 text-secondary">
                    {bidding.phones?.length > 0 ? <PhoneCard phones={bidding.phones} /> : '-'}
                  </div>
                  <div className="col-md-2 text-left text-md-right pr-0 bidding-info-title mt-2 mt-md-0">
                    Site
                  </div>
                  <div className="col-md-4 text-secondary">
                    {!bidding.edital_homepage1 && !bidding.edital_homepage2 && '-'}
                    {bidding.edital_homepage1 && (
                      <div className="row">
                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-link p-0 border-0"
                            onClick={(event) => {
                              event.preventDefault();
                              createTrack(`Card - Clicou em Site em ${source}`);
                              window.open(
                                bidding.edital_homepage1.includes('http')
                                  ? bidding.edital_homepage1
                                  : `http://${bidding.edital_homepage1}`,
                                '_blank',
                              );
                            }}
                          >
                            {bidding.edital_homepage1}
                          </button>
                        </div>
                      </div>
                    )}
                    {bidding.edital_homepage2 && (
                      <div className="row">
                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-link p-0 border-0"
                            onClick={(event) => {
                              event.preventDefault();
                              createTrack(`Card - Clicou em Site em ${source}`);
                              window.open(
                                bidding.edital_homepage2.includes('http')
                                  ? bidding.edital_homepage2
                                  : `http://${bidding.edital_homepage2}`,
                                '_blank',
                              );
                            }}
                          >
                            {bidding.edital_homepage2}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="border rounded-bottom border-top-0 d-print-none">
              <button
                type="button"
                key="btn-bidding-more-info"
                className="btn btn-sm btn-link m-0 w-100"
                onClick={() => {
                  setBiddingInfoToggle(!BiddingInfoToggle);
                  BiddingInfoToggle
                    ? createTrack(`Card - Clicou Ver menos informações da licitação em ${source}`)
                    : createTrack(`Card - Clicou Ver mais informações da licitação em ${source}`);
                }}
              >
                {BiddingInfoToggle
                  ? 'Ver menos informações da licitação'
                  : 'Ver mais informações da licitação'}
              </button>
            </div>

            {'highlights_json' in bidding &&
              bidding.highlights_json &&
              bidding?.highlights_json?.highlights?.length > 0 && (
                <>
                  <div className="row mt-2">
                    <div className="col-md-12 bidding-info-title">
                      Palavra-chave encontrada no edital
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 pl-5">
                      <ul className="list-highlight">
                        {bidding?.highlights_json.highlights.map((highlight) => (
                          <li
                            className="item-highlight"
                            dangerouslySetInnerHTML={{ __html: highlight || '-' }}
                          />
                        ))}
                        {bidding?.highlights_json?.count > 5 && (
                          <li>
                            {bidding.highlights_json.count >= 25
                              ? `...e ${bidding.highlights_json.count - 5} ou mais ocorrências`
                              : bidding.highlights_json.count - 5 === 1
                              ? `...e mais ${bidding.highlights_json.count - 5} ocorrência.`
                              : `...e mais ${bidding.highlights_json.count - 5} ocorrências.`}
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </>
              )}
            <div className="row bidding-info my-2 d-print-none">
              <div className="col-md-12 align-items-center d-flex flex-wrap">
                {source !== 'share' && (
                  <BiddingAttachmentList
                    biddingStatusEdital={bidding.edital_status_id}
                    biddingFiles={bidding.edicts}
                    requestEdital={requestEdital}
                    setRequestEdital={setRequestEdital}
                    solicited={solicited}
                    situation={bidding?.bidding_grouping?.descricao}
                    biddingValidade={bidding?.data_validade}
                  />
                )}
                {source !== 'share' && (
                  <>
                    {bidding?.has_summary === true && (
                      <BiddingSummaryButton
                        biddingId={
                          source === 'bulletin' || source === 'biddingDetails'
                            ? Number(bidding.bidding_id)
                            : bidding.id
                        }
                        editalDownload={{
                          biddingStatusEdital: bidding.edital_status_id,
                          biddingFiles: bidding.edicts,
                          situation: bidding?.bidding_grouping?.descricao,
                          biddingValidade: bidding?.data_validade,
                        }}
                        capagInfo={{
                          temCapag: bidding.public_body?.tem_capag,
                          capag: bidding.public_body?.capag,
                        }}
                      />
                    )}
                    {bidding?.indexed_for_ai === true && (
                      <BiddingChatButton
                        biddingId={
                          source === 'bulletin' || source === 'biddingDetails'
                            ? Number(bidding.bidding_id)
                            : bidding.id
                        }
                        source={source}
                        editalDownload={{
                          biddingStatusEdital: bidding.edital_status_id,
                          biddingFiles: bidding.edicts,
                          situation: bidding?.bidding_grouping?.descricao,
                          biddingValidade: bidding?.data_validade,
                        }}
                        capagInfo={{
                          temCapag: bidding.public_body?.tem_capag,
                          capag: bidding.public_body?.capag,
                        }}
                      />
                    )}
                  </>
                )}
                {bidding.itens && (
                  <button
                    onClick={() => {
                      setItemsOpened(!ItemsOpened);
                      createTrack(`Card - Clicou em Itens em ${source}`);
                    }}
                    type="button"
                    className="btn btn-sm btn-primary mr-1"
                  >
                    Itens{' '}
                    {ItemsOpened ? (
                      <span className="oi oi-caret-top item-arrow" />
                    ) : (
                      <span className="oi oi-caret-bottom item-arrow" />
                    )}
                  </button>
                )}
                {source !== 'share' && bidding.followups && bidding.followups?.length > 0 && (
                  <button
                    onClick={() => {
                      setFollowupOpened(!FollowupOpened);
                      createTrack(`Card - Clicou em Acompanhamentos em ${source}`);
                    }}
                    type="button"
                    className="btn btn-xs-block btn-sm btn-primary mr-1"
                  >
                    Acompanhamentos{' '}
                    {FollowupOpened ? (
                      <span className="oi oi-caret-top history-arrow" />
                    ) : (
                      <span className="oi oi-caret-bottom history-arrow" />
                    )}
                  </button>
                )}
                {'bidding_info' in bidding &&
                  bidding.bidding_info &&
                  bidding?.bidding_info?.length > 0 && (
                    <BiddingInfoDropdown
                      bidding_info={bidding?.bidding_info}
                      followup={[]}
                      contracts={[]}
                    />
                  )}
              </div>
            </div>
            {requestEdital && (
              <div className="row">
                <div className="col-md-12">
                  <div className="alert alert-warning d-flex px-0" role="alert">
                    {loading ? (
                      <div className="position-relative d-inline-block px-3">
                        Enviando solicitação
                        <SquareLoader customClass="solicited-edital-loading" />
                      </div>
                    ) : (
                      <>
                        <i className="material-icons me-2 text-warning mx-2">report</i>
                        <div>
                          <p className="text-dark mb-2">
                            <strong>Você deseja prosseguir com a solicitação?</strong>
                          </p>
                          <div className="form-check mb-1 text-muted">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`solicitar_${bidding.bidding_id}`}
                              id={`solicitarSim_${bidding.bidding_id}`}
                              value="sim"
                              onChange={() => handleClickEdital(bidding?.bidding_id)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`solicitarSim_${bidding.bidding_id}`}
                            >
                              Sim, quero solicitar o edital.
                            </label>
                          </div>
                          <div className="form-check text-muted">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`solicitar_${bidding.bidding_id}`}
                              id={`solicitarNao_${bidding.bidding_id}`}
                              value="nao"
                              onChange={() => setRequestEdital(false)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`solicitarNao_${bidding.bidding_id}`}
                            >
                              Não prosseguir.
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {messageEditalSuccess && (
              <div className="alert alert-success d-flex px-0" role="alert">
                <i className="material-icons me-2 text-success mx-2">check_circle</i>
                <div>
                  <p className="mb-0">
                    <strong>Recebemos sua solicitação!</strong>
                  </p>
                  <p className="mb-0">
                    Estamos tentando contato com o órgão e assim que obtiver a resposta enviaremos
                    no seu e-mail. Caso a resposta não chegue na caixa de entrada, verifique também
                    a caixa de SPAM.
                  </p>
                </div>
              </div>
            )}
            {bidding.itens &&
              ItemsOpened &&
              (source === 'biddings' ||
                source === 'biddingDetails' ||
                source === 'share' ||
                source === 'favorited') && <BiddingItems items={bidding.itens} source={source} />}
            {bidding.itens && ItemsOpened && source === 'bulletin' && (
              <BiddingItems
                items={bidding.itens}
                source={source}
                keywordsList={bulletins?.filter_bulletins[bulletinFilterIndex]?.bidding_keywords}
              />
            )}
            {bidding.followups && bidding.followups?.length > 0 && FollowupOpened && (
              <BiddingFollowupList loaded followups={bidding.followups} />
            )}
            {profile.partner_user && bidding.fonte_id && (
              <PartnerLogo partnerSourceId={bidding.fonte_id} />
            )}
            {(source === 'biddings' || source === 'bulletin' || source === 'favorited') && (
              <BiddingCommentsList
                biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                comments={bidding?.client_comments}
                bulletinFilterId={bulletinFilterId}
                source={commentSource}
              />
            )}
          </div>
        </div>
      </div>
      <ManagementTask
        modalManagementTaskOpened={modalManagementTaskOpened}
        setModalManagementTaskOpened={setModalManagementTaskOpened}
        bidding={bidding}
        taskType={taskType}
      />
      {modalOrganDetailsOpened && (
        <ModalOrganDetails
          bidding={bidding}
          setModalOrganDetailsOpened={setModalOrganDetailsOpened}
        />
      )}
      <ManagementRemoveBidding
        modalRemoveBiddingOpened={modalRemoveBiddingOpened}
        setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
        biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
        totalOpenedTaks={totalManagedTasks()}
        source={source}
        bulletinFilterId={bulletinFilterId}
      />
      <RobotComprasnetWarning
        setShowModal={setModalRobotWarningOpened}
        showModal={modalRobotWarningOpened}
      />
    </Container>
  );
};

export default BiddingItem;
